export default __webpack_public_path__ + "static/media/cover_color_2.f1efc9d9.png";